import React, { useEffect } from 'react';
const pixelId = '3178133015720491';
type PixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push?: unknown;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
// Meta Pixel Code — same logic as the official snippet. The script loads
// async, so it never blocks rendering.
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod.apply(n, args);else n.queue.push(args);
    } as PixelFunction;
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s?.parentNode) s.parentNode.insertBefore(t, s);else document.head.appendChild(t);
    n('init', pixelId);
    n('track', 'PageView');
  }, []);
  return <noscript data-id="element-83" data-mp="13ihwysijxn2u">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-84" data-mp="13j1iskbbovm5" />
    </noscript>;
}